import React from 'react';
import { RETURN_TO_PROJECT, TEST_IDS, COMPONENT_IDS } from './constants';
import { THANK_YOU } from './constants';
import { ReturnToPaperButton, ThankYouPanel, SuccessContentWrapper } from './styled';
var SuccessContent = function SuccessContent(_ref) {
  var onHostRedirect = _ref.onHostRedirect,
    siteName = _ref.siteName;
  return /*#__PURE__*/React.createElement(SuccessContentWrapper, {
    "data-testid": TEST_IDS.SUCCESS_CONTENT_WRAPPER,
    role: "dialog",
    "aria-labelledby": "payment-success-title",
    "aria-describedby": "payment-success-description"
  }, /*#__PURE__*/React.createElement(ThankYouPanel, {
    id: COMPONENT_IDS.PAYMENT_SUCCESS_TITLE
  }, THANK_YOU), /*#__PURE__*/React.createElement(ReturnToPaperButton, {
    onClick: onHostRedirect,
    "data-testid": TEST_IDS.RETURN_TO_PROJECT_BUTTON,
    siteName: siteName,
    id: COMPONENT_IDS.PAYMENT_SUCCESS_DESCRIPTION
  }, RETURN_TO_PROJECT));
};
export default SuccessContent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/SuccessContent/index.js
// module id = 5228
// module chunks = 11